import React from 'react'
import {Row, Col} from 'reactstrap'

const MenuHeader = (props) => {
    return (
        <div>
           <Row>
                <h1 className="category-title">{props.name}</h1>
           </Row>
           <Row>
                <p className="item-card-description">{props.description}</p>
           </Row>
        </div>
    )
}
export default MenuHeader